"use client";

import { TranslationFallbackBoundary } from "@/components/error/TranslationFallbackBoundary";

export default function PublicLayout({
  children,
}: {
  children: React.ReactNode;
}) {
  return (
    <div>
      <TranslationFallbackBoundary>{children}</TranslationFallbackBoundary>
    </div>
  );
}
